import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function select(id: string) {
    setSelected(id);
    setOpen(false);
  }

  return (
    <div className="relative w-full max-w-md" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between rounded-full border border-background-200 bg-background-50 px-5 py-3.5 text-left text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 whitespace-nowrap"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="flex items-center gap-2 truncate">
          <i className="ri-grid-line w-4 h-4 flex items-center justify-center text-primary-500"></i>
          <span className="truncate">
            {selected ? t(`cat.${selected}`) : t('dropdown.placeholder')}
          </span>
        </span>
        <i className={`ri-arrow-down-s-line w-4 h-4 flex items-center justify-center text-foreground-500 transition-transform ${open ? 'rotate-180' : ''}`}></i>
      </button>

      {open && (
        <ul
          className="absolute left-0 right-0 z-40 mt-2 max-h-72 overflow-auto rounded-xl border border-background-200 bg-background-50 py-1 shadow-sm"
          role="listbox"
        >
          {categories.map((c) => (
            <li key={c.id}>
              <a
                href={c.url}
                target="_blank"
                rel="noopener nofollow"
                onClick={() => select(c.id)}
                className="flex items-center justify-between px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 whitespace-nowrap"
                role="option"
              >
                <span>{t(`cat.${c.id}`)}</span>
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center text-foreground-400"></i>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}